/**
 * @file information-required.tsx
 * @deprecated Copied to app/modules/procurement/pages/vendors_management/kyc-verification/information-required.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/vendors_management/kyc-verification/information-required
 * @description Page component for managing information required KYC verification in the vendors management section.
 *   Displays a list of information required KYC verification with pagination, search functionality, and CRUD operations.
 *   Allows users to view the details of information required KYC verification with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { MouseEvent, useState } from "react";
import { Button, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../../Global/loader";
import Pagination from "../../../../../Global/pagination";
import Method from "../../../../../utils/methods";
import UpdatedKycDetails from "../../../../modals/updated-kyc-details";
import ViewRequiredInfo from "../../../../modals/view-required-info";
import { setKey } from "../../../../../Global/history";
import { listKycVerification } from "../../../../../utils/storeString";
import {
  AllSeller,
  KycVerifications,
  View,
} from "../../../../../utils/constants";
import { useAuth } from "../../../auth";
import PermissionModal from "../../../../modals/permission";
const InformationRequired = (props: any) => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [sortClass, setSortClass] = useState({
    ownerName: 1,
    name: 1,
    _createdAt: 1,
  });
  const changeSortClass = (event: MouseEvent<HTMLTableCellElement>) => {
    let currentValue = (event.target as HTMLTableCellElement).abbr;
    let sort = sortClass;
    sort = {
      ...sort,
      [currentValue]: sort[currentValue as keyof typeof sort] === 1 ? -1 : 1,
    };
    setSortClass(sort);
    // props.onSorting(
    //   currentValue,
    //   sort[currentValue as keyof typeof sort] === 1 ? -1 : 1,
    // )
  };
  const renderTooltip = (props: any) => (
    <Tooltip className="tooltip w-lg-275px" {...props}>
      <p className="text-white mb-0 fs-14 fw-500">
        This seller has updated business details, category, logo, type,
        certificates.
      </p>
      <span className="text-muted fw-13">Updated on 12/01/2023</span>
    </Tooltip>
  );
  const handleSellerProfile = (id: string) => {
    let currentScrollY = window.scrollY;
    setKey(listKycVerification.scrollPosition, currentScrollY);
    setKey(listKycVerification.search, props.search, false);
    navigate("/UProcure/vendors/vendor-profile", {
      state: { id: id, moduleName: KycVerifications },
    });
  };
  const handleShowInfo = () => {
    setShowInfo(!showInfo);
  };
  return (
    <>
      {showPermissionModal && (
        <PermissionModal
          show={showPermissionModal}
          onHide={() => setShowPermissionModal(false)}
          moduleName={"seller"}
        />
      )}
      {props.fetchLoader || !props.sellerData ? (
        <>
          <div className="d-flex justify-content-center">
            <Loader loading={true} />
          </div>
        </>
      ) : props.sellerData.length ? (
        <>
          <div className="table-responsive mt-2">
            <table className="table table-row-bordered align-middle gy-6 gs-7">
              <thead>
                <tr className="fw-bold fs-16 text-black">
                  <th
                    // className={
                    //   sortClass.ownerName === 1
                    //     ? 'table-sort-asc'
                    //     : 'table-sort-desc'
                    // }
                    className="min-w-lg-200px"
                    abbr="ownerName"
                    // onClick={(e) => {
                    //   changeSortClass(e)
                    // }}
                  >
                    Seller name
                  </th>
                  <th
                    abbr="name"
                    // className={
                    //   sortClass.name === 1
                    //     ? 'table-sort-asc'
                    //     : 'table-sort-desc'
                    // }
                    className="min-w-lg-200px"
                    // onClick={(e) => {
                    //   changeSortClass(e)
                    // }}
                  >
                    Business name
                  </th>
                  <th
                    abbr="_createdAt"
                    // className={
                    //   sortClass._createdAt === 1
                    //     ? 'w-125px table-sort-asc'
                    //     : 'w-125px table-sort-desc'
                    // }
                    className="min-w-lg-150px"
                    // onClick={(e) => {
                    //   changeSortClass(e)
                    // }}
                  >
                    Joined on
                  </th>
                  <th className="min-w-lg-250px">Actions</th>
                </tr>
              </thead>
              <tbody>
                {props.sellerData.map((sellerVal: any, index: number) => {
                  return (
                    <tr>
                      <td className="fs-15 fw-500 text-dark">
                        {sellerVal.ownerName}
                        {sellerVal._updatedAt ===
                        sellerVal.KYC.profileUpdatedAt ? (
                          <>
                            <div
                              className="bg-light-primary w-fit-content p-1 px-2 mb-2 border-r5px"
                              onClick={handleShowInfo}
                            >
                              <span className="text-primary fs-14 fw-500">
                                New info available
                              </span>
                            </div>
                            <>
                              {showInfo ? (
                                <UpdatedKycDetails
                                  show={showInfo}
                                  ownerName={sellerVal.ownerName}
                                  _id={sellerVal._id}
                                  onHide={() => {
                                    setShowInfo(!showInfo);
                                  }}
                                  moduleName={KycVerifications}
                                />
                              ) : (
                                <></>
                              )}
                            </>
                          </>
                        ) : (
                          <></>
                        )}
                      </td>
                      <td className="fs-15 fw-500 text-dark">
                        {sellerVal.name}
                      </td>
                      <td className="fs-15 fw-500 text-dark">
                        {Method.convertDateToDDMMYYYY(sellerVal._createdAt)}
                      </td>
                      <td>
                        <div className="d-inline-flex">
                          {Method.hasPermission(
                            KycVerifications,
                            View,
                            currentUser
                          ) &&
                          Method.hasPermission(AllSeller, View, currentUser) ? (
                            <Button
                              className="uw-btn uw-btn-primary btn btn-primary fs-14 fw-600"
                              onClick={() => {
                                handleSellerProfile(sellerVal._id);
                              }}
                            >
                              View details
                            </Button>
                          ) : (
                            <></>
                          )}
                          {Method.hasPermission(
                            KycVerifications,
                            View,
                            currentUser
                          ) &&
                          !Method.hasPermission(
                            AllSeller,
                            View,
                            currentUser
                          ) ? (
                            <Button
                              className="uw-btn uw-btn-primary btn btn-primary fs-14 fw-600"
                              onClick={() => {
                                setShowPermissionModal(true);
                              }}
                            >
                              View details
                            </Button>
                          ) : (
                            <></>
                          )}
                          <ViewRequiredInfo
                            ownerName={sellerVal.ownerName}
                            message={sellerVal.KYC.statusMessage}
                            handleEdit={props.handleEdit}
                            handleClose={props.handleClose}
                            edit={props.edit}
                            saveChanges={() => {
                              props.saveChanges(index);
                            }}
                            onMessageChange={(event: any) => {
                              props.onMessageChange(event, sellerVal, index);
                            }}
                            statusLoading={props.statusLoading}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Pagination
              totalRecords={props.total}
              currentPage={props.currentPage}
              handleCurrentPage={(event: any) => {
                props.handleCurrentPage(event, 4);
              }}
              handleNextPage={(event: any) => {
                props.handleNextPage(event, 4);
              }}
              handlePreviousPage={(event: any) => {
                props.handlePreviousPage(event, 4);
              }}
              pageLimit={parseInt(props.pageLimit)}
              handlePageLimit={(event: any) => {
                props.handlePageLimit(event, 4);
              }}
            />
          </div>
        </>
      ) : (
        <>
          <div className="d-flex flex-column flex-center h-100px">
            <p className="fs-18 fw-500">No records available.</p>
          </div>
        </>
      )}
    </>
  );
};
export default InformationRequired;
